import React from 'react';
import './CryptoForm.css';
import DarkModeImage from './darkmode.png'; // Import the dark mode image

const LandingPage = () => {
  return (
    <div className="dark-mode"> {/* Ensure dark mode is always applied */}
      <div className="image-container">
        <img src={DarkModeImage} alt="Dark Mode" className="cta-image active transparent-bottom" />
      </div>
    </div>
  );
};

export default LandingPage;
